import React from "react"

let index = -1

const faq = faq => {
  index++
  return {
    id: index,
    ...faq,
  }
}

export const faqs = [
  faq({
    question: "WHAT IS STC30™?",
    answer:
      "STC30™ - Superlife Total Care 30 stemcell max is plants stem cells combination by using Swiss Plant Stem Cell Technology – PhytoCellTec™ Malus Domestica (Apple Stem Cell) and PhytoCellTec™ Solar Vitis (Grape Stem Cell) known as Double Stem cells , enriched with GliSODin® CANTALOUPE and GliSODin® GLIADIN (France Technology), Bilberry and Black Currant - Helps to reduce cellular oxidative damage, support cellular antioxidant defences. Promotes the production of body’s natural antioxidant system, supports healthy immune function and to nourish your skin from within, provide you with a significant result.",
  }),
  faq({
    question: "HOW DOES STEM CELL WORK?",
    answer:
      "Stem cells are special, very valuable cells that are present in small numbers in almost every tissue, including the skin. Only stem cells can divide over the course of a person’s life and create new skin cells, continuously renewing the epidermis. As we age, the vitality and number of skin stem cells decreases, the epidermis takes longer to renew itself and wrinkles form.",
  }),
  faq({
    question: "WHAT MAKES PHYTOCELLTEC ACTIVE INGREDIENT SO INNOVATIVE?",
    answer:
      "They have made it possible to promote the vitality of skin stem cells for the first time. Extracts obtained from plant stem cells using state-of-the-art technology have specific stem cell factors, which help skin stem cells retain their properties. PhytoCellTec™ active ingredients have been shown to have a positive effect on cultures of epidermal stem cells.",
  }),
  faq({
    question:
      "WHAT MAKES ACTIVE INGREDIENT FROM PLANT STEM CELL BETTER THAN TRADITIONAL PLANT EXTRACT?",
    answer:
      "PhytoCellTec™ active ingredients are extracted from pure plant stem cell cultures. Stem cells (plant and human) have specific epigenetic factors and only these components give cells the ability to act as stem cells. In traditional plant extracts these factors are present only to a very limited extent.",
  }),
  faq({
    question: "HAVE PHYTOCELLTEC ACTIVE INGREDIENT BEEN TESTED ON ANIMALS?",
    answer:
      "Mibelle Biochemistry has never tested PhytoCellTec™ active ingredients on animals either during development or for proof of activity. The active ingredients were tested only on cell cultures and, in the form of finished products, on test subjects. These highly specific tests were conducted in cooperation with renowned dermatological test institutes.",
  }),
  faq({
    question: "AT WHAT AGE CAN BE PRODUCT BE USED?",
    answer:
      "As PhytoCellTec™ active ingredients have a very good, protective effect that prevents aging of the skin, they are recommended for younger and mature skin.",
  }),
  faq({
    question: "CAN I PURCHASE STC30 AT A PHARMACY IN MY AREA?",
    answer:
      "Our products can only be purchased online on our website (like the one you're currently on) or through our independent distributors only.",
  }),
  faq({
    question: "CAN STC30 BE ADMINISTERED TO CHILDREN? ",
    answer:
      "Yes, it can be consumed by children, under adult supervision. Half sachet for children under 12 years of age. This product is safe and Non-Toxic.",
  }),
  faq({
    question: "IS IT SAFE TO CONSUME STC30?",
    answer:
      "Double Stemcell™ has registered with Health Ministry Malaysia (KKM) and it has went through Standards and Industrial Research Institute of Malaysia (SIRIM) and SGS Singapore General Laboratory Testing Standard. This product is confirmed safe and 100% plant base.",
  }),
  faq({
    question: "WHAT DISEASES CAN STC30 HELP CORRECT?",
    answer: (
      <React.Fragment>
        Cardiovascular disorders
        <br />
        ⏩ Improve blood flow
        <br />
        ⏩ Skin infections
        <br />
        ⏩ Liver problems
        <br />
        ⏩ Anti stress
        <br />
        ⏩ Eye problems
        <br />
        ⏩ Joint problems
        <br />
        ⏩ Hemorrhoids
        <br />
        ⏩ Hypertension
        <br />
        ⏩ Osteoarthritis
        <br />
        ⏩ Liver problems
        <br />
        ⏩ Gastrointestinal disorders
        <br />
        ⏩ Kidney disease
        <br />
        ⏩ Anti aging
        <br />
        ⏩ Burns
        <br />
        ⏩ Diabetes
        <br />
        ⏩ Heart disease
        <br />
        ⏩ Stroke
        <br />
        ⏩ Spinal cord injuries
        <br />
        ⏩ Muscular degeneration
        <br />
        ⏩ Prostate disorders
        <br />
        ⏩ All kind of cancers (even at stage 4)
        <br />
        ⏩ Memory problem
        <br />
        ⏩ Sleeping problem
        <br />
        ⏩ Infertility problem
        <br />
        ⏩ Impotence or poor sexual performance
        <br />⏩ etc
      </React.Fragment>
    ),
  }),
  faq({
    question: "DOES STC30 HAVE ANY SIDE EFFECTS?",
    answer:
      "STC30 have no side effects! In fact the company has placed a $1 million compensation for anyone who uses the product and develops any major side effects.",
  }),
]
